import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { AttatchFileTrainComponent } from "../../../components/borrowSystem/BorrowForm/AttatchFileTrainComponent";
import { Footer } from "../../../components/share/Footer";

export function AttatchFileTrainContainer() {
  const titleName = "แผนที่ตั้งของสถานที่ดำเนินการฝึกอบรม";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AttatchFileTrainComponent />
      <Footer />
    </div>
  );
}
